// test1186
(1186 && 0);
